// extracted by mini-css-extract-plugin
export default {"header":"Header_header__wzrIX","headerContent":"Header_headerContent__QrYCa","section":"Header_section__CSRKP","logo":"Header_logo__k4soh","menuControl":"Header_menuControl__BBpxu"};